import { Component, OnInit } from '@angular/core';
import { DataSourcesService } from '../data-sources.service';
import { NgClass, NgFor } from '@angular/common';

@Component({
  selector: 'app-data-sources-controls',
  templateUrl: './data-sources-controls.component.html',
  styleUrls: [
    './data-sources-controls.component.scss',
    '../../../../app.component.scss',
  ],
  imports: [NgFor, NgClass],
})
export class DataSourcesControlsComponent implements OnInit {
  constructor(public dataSourcesService: DataSourcesService) {}

  ngOnInit(): void {}
}
